/**
 * 与浏览器相关的一些方法, 获取浏览器版本
 */
export function getQueryParam(param){
  const url = window.location.href;
  const urlParams = new URLSearchParams(new URL(url).search);
  return urlParams.get(param)
}
/**
 * 返回 LCID
 */
export function getLanguage() {
  const url_lang = getQueryParam('lang')
  if (url_lang) {
    return url_lang
  }
  const navigator = window.navigator
  const lang = navigator.language.toLowerCase()
  const langActive = ['ja', 'ko']
  let language = lang

  // 兼容 ja-xx, ko-xx, de-xx 的情况
  langActive.forEach(item => {
    if (lang.startsWith(item)) {
      language = item
    }
  })
  // langActive.filter(item=>{
  //   if ((lang.toLowerCase()).indexOf(item) != -1) {
  //     language = item
  //     return item
  //   }
  // })
  
  return language
}

/**
 * 预加载图片资源
 * @param {string} url
 */
export function preloadImage(url) {
  const img = new Image()
  img.src = url
}

const KEY_IOS = 'iOS'
const KEY_ANDROID = 'Android'

function judgeClient() {
  if (typeof navigator === 'undefined') return ''
  const u = navigator.userAgent
  let client = ''
  if (/(iPhone|iPad|iPod|iOS)/i.test(u)) {
    client = KEY_IOS
  } else if (/(Android)/i.test(u)) {
    client = KEY_ANDROID
  }
  return client
}

const client = judgeClient()

export const isIOS = client === KEY_IOS
export const isAndroid = client === KEY_ANDROID
export const isSafari = typeof window !== 'undefined' && /Safari/.test(window.navigator.userAgent)
